import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-confirm-close-dialog',
  templateUrl: './confirm-close-dialog.component.html',
  styleUrls: ['./confirm-close-dialog.component.scss'],
  imports: [MatButtonModule, TranslateModule, MatDialogModule],
})
export class ConfirmCloseDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ConfirmCloseDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      title: string;
      text: string;
      secondText?: string;
    },
    public dialog: MatDialog
  ) {}

  onCancelBtnClicked(isClose: boolean): void {
    this.dialogRef.close({ isClose });
  }
}
